import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const FIRST_PIE_CHART_HELPER = data => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      className: "chart-background",
      spacingBottom: 50,
      height: 450,
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.FIRST._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center"
    },
    subtitle: {
      ...chartConfig.subtitle,
      y: 25,
      enabled: true,
      verticalAlign: "bottom"
    },
    plotOptions: {
      series: {
        animation: false
      },
      pie: {
        showInLegend: true,
        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            }
          }
        }
      }
    },
    series: [
      {
        name: "Issues",
        data: [],
        dataLabels: {
          enabled: true,
          format: `<span style="color:{point.color}">{point.y}</span>`
        }
      }
    ],
    legend: {
      enabled: true,
      verticalAlign: "bottom"
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Projects: ${this.y}</b>
              `;
      }
    }
  };

  try {
    // set data
    const {
      projectImplementationModeCountDTOList: list = [],
      totalActiveProjects = 0
    } = data;
    PieChartConfig.series[0]["data"] = list.map((val, index) => {
      return { name: val.implementationMode, y: val.count };
    });
    PieChartConfig.title.text = `UNDER CONSTRUCTION / UNDER IMPLEMENTATION : ${totalActiveProjects} PROJECTS`;
    PieChartConfig.subtitle.text = `Implementation mode within ${totalActiveProjects} PMG monitored projects`;
    return PieChartConfig;
  } catch (error) {
    console.error(error);
  }
};
